export default{
  getHdList: process.env.VUE_APP_API_PREFIX + '/hd/data/user', //个人数据
  getWxConfig: process.env.VUE_APP_API_PREFIX + '/hd/six-one-eight/wx-share' //微信分享
}